import { call, put, takeLatest, } from 'redux-saga/effects';

import { fetchProductsAttributes as actions, } from './actions';
import * as types from './types';
import { ProductsAttributesErrorType, } from './types';
import { repositories, } from 'api'
import { getErrorProperties, } from 'common/functions';

export {
    actions,
};

const attributes = new repositories.products.Attributes();

function* fetchAttributes() {
    try {
        const { data, } = yield call([ attributes, 'get', ]);

        yield put(actions.success(data));
    } catch (error) {
        yield put(actions.failure(getErrorProperties<ProductsAttributesErrorType>(error)));
    }
}

function* productsAttributesSaga() {
    yield takeLatest(types.FETCH_PRODUCTS_ATTRIBUTES_REQUEST, fetchAttributes);
}

export default productsAttributesSaga;
